import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    applyPrizeBoth,
} from './../../../actions/FilterActions';
import common from '../../../common';
import OutsideNotifier from '../../../OutsideNotifier';
import config from './../../../config';
import {
    getWildCardStatus,
    getBoosterStatus,
} from "../../../helper-common";

class PrizeFilterMobile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dropDownActive: false,
            priceLable: this.props.trans.unlimited ? this.props.trans.unlimited : "unlimited"
        }
    }

    onPriceFilterClick = (e, priceID, el) => {
        e.stopPropagation();
        let currentFixture = { "GDID": 0 };
        if (this.props.userSpecificFixtures && this.props.userSpecificFixtures.length) {
            currentFixture = this.props.userSpecificFixtures[(this.props.currentActiveFixture || 0)];
        }

        const {
            GDID
        } = currentFixture;

        const limitlessStatus = getBoosterStatus(this.props.teamData, GDID || 0);

        this.setState({
            priceLable: el.label
        })
        if (limitlessStatus == config.limitlessBoosterStatus["usedInCurrentTemp"] && priceID == 101) {
            this.props.applyPrizeBoth(102);
        } else {
            this.props.applyPrizeBoth(priceID);
        }

        common.customTracking('Select Price filter - ' + (config.priceTrans[priceID] ? config.priceTrans[priceID] : el.label),common.getPageName());

        this.toggleDrpDown()
    };
    toggleDrpDown(val) {
        if (val == false) {
            this.setState({
                dropDownActive: false
            })
        } else {
            this.setState({
                dropDownActive: !this.state.dropDownActive
            })
            if (!this.state.dropDownActive) {
                // common.customTracking('Price - Filters');
            }
        }
    }

    getPriceLable = (id) => {
        var priceLable = ""
        if (id >= 100) {
            priceLable = this.props.trans[config.priceFilterObj[id].label] ? this.props.trans[config.priceFilterObj[id].label] : config.priceFilterObj[id].label;
        } else if (id < 100) {
            priceLable = config.priceFilterObj[id].label ? (this.props.trans.upTo ? this.props.trans.upTo : "upTo") + " " + config.priceFilterObj[id].label + this.props.trans.million : "m"
        } else {
            priceLable = config.priceFilterObj[id].label
        }
        return priceLable;
    }

    render() {
        const className = common.makeClasses({
            'si-drpDwn': true,
            'si-active': this.state.dropDownActive,
        });
        const selectedClass = common.makeClasses({
            "si-drpDwn__value": true,
            "si-flexBox": true,
            "si-selected-option": this.props.priceFilterSelected[0] != 100
        })
        return <div className="si-filter-types si-price-filter">
            <span className="si-title">{ this.props.trans.filterByPrice }</span>
            <OutsideNotifier
                handler={ () => this.toggleDrpDown(false) }>
                <div className="sorting-wrap si-flexBox">
                    <div className="si-form__control">
                        <div className={ className }>
                            { this.state.dropDownActive == true ? <div className="si-hidden-ctn" onClick={ (e) => this.toggleDrpDown(e, false) }></div> : null }
                            <div className={ selectedClass } onClick={ (e) => { e.stopPropagation(); this.toggleDrpDown() } }>
                                <span>{ this.getPriceLable(this.props.priceFilterSelected[0]) }</span>
                            </div>
                            <div className="si-drpDwn__list">

                                <ul>
                                    { this.props.priceFilter.map(el => {
                                        const className = common.makeClasses({
                                            'si-price-range': true,
                                            'si-selected': this.props.priceFilterSelected.indexOf(el.id) > -1,
                                            'si-display-none': el.id == 102
                                        });
                                        return <li className={ className } key={ el.id } onClick={ (e) => {
                                            this.onPriceFilterClick(e, el.id, el)
                                        } }>{ this.getPriceLable(el.id) }</li>
                                    }) }
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </OutsideNotifier>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        priceFilter: state.formationData.priceFilter,
        priceFilterSelected: state.formationData.playerFilters.priceFilterSelected,
        teamData: state.formationData.teamData,
        userSpecificFixtures: state.formationData.userSpecificFixtures,
        currentActiveFixture: state.formationData.currentActiveFixture,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        applyPrizeBoth: (priceID) => dispatch(applyPrizeBoth(priceID)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(PrizeFilterMobile);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/PrizeFilterMobile.js